import Vue from 'vue';
import PortalTarget from './portal-target.js';
import { getTarget } from '../../utils/dom.js';
import { warn } from '../../utils/console.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var Portal = Vue.extend({
  name: 'Portal',
  props: {
    disabled: {
      type: Boolean
    },
    appendTo: {
      type: [String, Element, Boolean],
      default: 'body'
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(disabled) {
        if (disabled) {
          this.unmount();
        } else {
          this.$nextTick(this.mount);
        }
      }
    }
  },
  updated: _async(function () {
    const _this = this;
    return _await(_this.$nextTick(), function () {
      if (!_this.disabled && _this.slotFn !== _this.$scopedSlots.default) {
        _this.container.updatedNodes = _this.$scopedSlots.default;
      }
      _this.slotFn = _this.$scopedSlots.default;
    });
  }),
  beforeDestroy() {
    this.unmount();
  },
  methods: {
    mount() {
      const targetEl = getTarget(this.appendTo);
      if (!targetEl) {
        warn(`[pendo-portal]: could not locate portal target ${targetEl}`, this);
        return;
      }
      const el = document.createElement('div');
      targetEl.appendChild(el);
      this.container = new PortalTarget({
        el,
        parent: this,
        propsData: {
          nodes: this.$scopedSlots.default
        }
      });
    },
    unmount() {
      if (this.container) {
        this.container.$destroy();
        delete this.container;
      }
    }
  },
  render(createElement) {
    if (this.disabled) {
      const nodes = this.$scopedSlots && this.$scopedSlots.default();
      if (!nodes) {
        return createElement();
      }
      if (nodes.length < 2 && !nodes[0].text) {
        return nodes;
      }
      return createElement('div', nodes);
    }
    return createElement();
  }
});

export { Portal as default };
//# sourceMappingURL=portal.js.map
